import { Timeline, } from 'antd';
import { ToastContainer, toast } from 'react-toastify';
import { Cookies } from 'react-cookie';
import { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Footer from '../../Layout/FooterComponent';
const cookies = new Cookies();

const TrackingTrunkForm = () => {
    const [trackingData, setTrackingData] = useState([]);
    const navigate = useNavigate()
    const [showStatusBox, setShowstatusBox] = useState(false);
      
    const [EventCodeAutoComplete, setEventCodeAutoComplete] = useState([]);
    const [formData, setFormData] = useState({
        EventCode: '',
        TrunkId: "",
    });
    const params = new URLSearchParams(window.location.search);
    const TrackingID = params.get('trunK_ID');
    if (TrackingID) {
        formData.TrunkId = TrackingID;
    }
    const inputRefs = useRef([]);
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode')
    const [filterData, setFilterData] = useState({
        SearchText: "",
        StartValue: "1",
        SearchFieldValue: "",
    })
    var data = [];
    for (let i = trackingData.trackingData?.length - 1; i >= 0; i--) {
        data.push({

            label: <p>  
                <span>   {trackingData.trackingData[i].image !== "" ? <Link style={{ cursor: 'pointer' }} to={`/Images#data:image/png;base64,${trackingData.trackingData[i].image}`} target="_blank">
                    <i className="fa fa-image" style={{ fontSize: "19px", color: "blue" }}></i>
                </Link> : <></>}

                </span>
                &nbsp;&nbsp;
                <span>{trackingData.trackingData[i].map !== "" ? (

                    <a type="button" href={trackingData.trackingData[i].map} target="_blank"> <i className="fas fa-map-marker-alt" style={{ color: "blue" }}></i></a>
                ) : (
                    <></>
                )} </span>
                {trackingData.trackingData[i].createdDate}  &nbsp;

                <br />  </p>,
            children: <p>{trackingData.trackingData[i].packetStatus} <br /></p>
        })
    }

    const Tracking = async () => {

        if (formData.TrunkId !== '') {
            const data = {
                ...filterData,
                ...formData,
                Token: cookies.get('token'),
                LoginUserCode: cookies.get('loginUserCode'),
                Source: 'web',
                Type: 'S',
                PageIndex: '1',
                PageSize: '20',
            }
            await fetch(`/api/ReportController/Tracking`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                },
            }).then(async (response) => {
                let res = await response.json();
                var TrackingDetails = res;
                if (res.status === "SUCCESS") {
                    setTrackingData(TrackingDetails)
                    setShowstatusBox(true)
                } else if (res.message === "EXPIRED") {
                    navigate("/login")

                }

                else if (res.status === 'ERROR') {
                    setTrackingData([])
                    setShowstatusBox(false)
                    toast.error(res.message, {

                    })
                    inputRefs.current['txtTrunkId'].focus();
                }
            }).catch((err) => {
                toast.error(err.message, {

                })

            });
        } else {
            toast.error('Please Enter TrunkID')
            inputRefs.current['txtTrunkId'].focus();
        }
    }
    const EventDropdownList = async (EventId) => {
        let data = { Token, LoginUserCode, EventId }
        await fetch('/api/MasterController/GetEvent',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setEventCodeAutoComplete(res.eventList);
            }).catch((err) => console.log(err));

    };

    useEffect(() => {


        //document.title = "tracking Trunk"
        document.title = "Trunk Tracking"
        if (formData.TrackingID !== null || formData.TrackingID !== "") {
            Tracking();
        }
    }, [])

    return (
        <>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box pb-3">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{'Trunk Tracking'}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row ">
                                    <div className="col-lg-3 col-md-6 col-sm-6 " style={{ display: "none" }}>
                                        <div className="fields">
                                            <label className="form-label">Event  <span className="Required">*</span></label>
                                            <select
                                                ref={ref => (inputRefs.current['ddlEventCode'] = ref)}
                                                id="inputState"
                                                className="form-select"
                                                value={formData.EventCode}
                                                onChange={(e) => setFormData({ ...formData, EventCode: e.target.value })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtTrunkId'].focus()
                                                    };
                                                }}
                                            >
                                                <option value=''>Select Event </option>
                                                {
                                                    EventCodeAutoComplete?.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.eventCode}>{item.eventName}</option>
                                                        )
                                                    })
                                                }
                                            </select>

                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 col-sm-6 ">
                                        <div className="fields">
                                            <label className="form-label">Trunk ID  <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtTrunkId'] = ref)}
                                                type="text"
                                                className="form-control"
                                                placeholder="Trunk ID"
                                                autoComplete="off"
                                                maxLength='10'
                                                value={formData.TrunkId}
                                                onChange={(e) => setFormData({ ...formData, TrunkId: e.target.value })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        Tracking()
                                                    };
                                                }}
                                            />
                                        </div>

                                    </div>
                                    <div className="row col-lg-3 col-md-3 col-sm-6 mt-4">
                                        <div className="lms-new-button   ">
                                            <button className="button save-btn" onClick={Tracking} >
                                                Track Status
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                (trackingData !== null ?
                                    (showStatusBox ?
                                        <div className='form-box service-content-area mt-6 ms-3 me-3 d-flex '>
                                            <div className='col-lg-5 col-md-5 border password-policy1-border p-0 border-1 ' style={{ height: "282px", }}>
                                                <div className=' password-policy1 py-3 px-4 ' >
                                                    <h2 style={{ fontWeight: "bold", padding: "6px", display: "flex", justifyContent: "center", marginBottom: "2px", fontSize: "18px" }}><u>Tracking Details</u></h2>
                                                    <br/>
                                                    <table className="table">
                                                        <tbody>
                                                            <tr >
                                                                <td style={{ backgroundColor:"#f7faff", }}> <h2 style={{ fontWeight: "bold", fontSize: "13px" }} >EVENT</h2></td>
                                                                <td style={{ backgroundColor: "#f7faff", }}> <h2 style={{ fontWeight: "bold", fontSize: "13px" }} >{trackingData.trackingData[0].event} </h2></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ backgroundColor: "#f7faff", }}> <h2 style={{ fontWeight: "bold", fontSize: "13px" }} >Venue</h2></td>
                                                                <td style={{ backgroundColor: "#f7faff", }}> <h2 style={{ fontWeight: "bold", fontSize: "13px" }} >{trackingData.trackingData[0].venue} </h2></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ backgroundColor: "#f7faff", }}> <h2 style={{ fontWeight: "bold", fontSize: "13px" }} >Custodian</h2></td>
                                                                <td style={{ backgroundColor: "#f7faff", }}> <h2 style={{ fontWeight: "bold", fontSize: "13px" }} >{trackingData.trackingData[0].custodian} </h2></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ backgroundColor: "#f7faff", }}> <h2 style={{ fontWeight: "bold", fontSize: "13px" }} >District</h2></td>
                                                                <td style={{ backgroundColor: "#f7faff", }}> <h2 style={{ fontWeight: "bold", fontSize: "13px" }} >{trackingData.trackingData[0].district} </h2></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ backgroundColor: "#f7faff", }}> <h2 style={{ fontWeight: "bold", fontSize: "13px" }} >Client representative</h2></td>
                                                                <td style={{ backgroundColor: "#f7faff", }}> <h2 style={{ fontWeight: "bold", fontSize: "13px" }} >{trackingData.user}</h2></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    {/*<ul >*/}
                                                    {/*    <li className="    " >*/}
                                                    {/*        <h2 style={{ fontWeight: "bold", marginTop: "1px", fontSize: "15px" }} >Event {trackingData.trackingData[0].event} </h2><br />*/}
                                                    {/*        <h2 style={{ fontWeight: "bold", marginTop: "1px", fontSize: "15px" }} >Venue{trackingData.trackingData[0].venue} </h2><br />*/}
                                                    {/*        <h2 style={{ fontWeight: "bold", marginTop: "1px", fontSize: "15px" }}>Custodian {trackingData.trackingData[0].custodian} </h2><br />*/}
                                                    {/*        <h2 style={{ fontWeight: "bold", marginTop: "1px", fontSize: "15px" }}>District{trackingData.trackingData[0].district} </h2><br />*/}
                                                    {/*        <h2 style={{ fontWeight: "bold", marginTop: "1px", fontSize: "15px" }}>Client representative {trackingData.user} </h2><br />*/}

                                                    {/*    </li>*/}
                                                    {/*</ul>*/}
                                                </div>


                                            </div>

                                            <div className='px-2 py-2 col-lg-5 col-md-5'>
                                                <h2 style={{ fontWeight: "bold", marginTop: "2px", padding: "10px", fontSize: "20px", alignItems: "center", display: "none" }}>Tracking Id #{trackingData.trackingData[0].trunkID}</h2>
                                                <div className="form-group px-2 ">

                                                    <div>

                                                        {/*<div className="totalrecord ms-2 mb-3 d-flex" style={{  fontWeight: 'bold' }}>*/}
                                                        {/*    {trackingData.user !== undefined && trackingData.user !== null ?*/}
                                                        {/*        (`User : ${trackingData.user}`)*/}
                                                        {/*        :*/}
                                                        {/*        (``)}*/}
                                                        {/*</div>*/}
                                                        <Timeline
                                                            mode="left"
                                                            items={data} />

                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                        : <></>) : <></>)}
                        </div>
                    </div>
                </div>


            </section>
            <ToastContainer theme='colored' />
            <Footer />
        </>
    )
}
export default TrackingTrunkForm;
